// ============================================================================
// RAT IN MAZE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'rat-in-maze',
  name: 'Rat in a Maze',
  category: 'Backtracking',
  complexity: {
    time: 'O(2^(n*m))',
    space: 'O(n*m)'
  },
  description: 'Rat in a Maze finds a path for a rat from the starting position to the destination in a maze using backtracking.'
};
export type MetaType = typeof meta;
